import { MdOutlineClose, MdOutlineStorefront } from 'react-icons/md';

import { Button } from '@components/Button';

import { getUserAgent } from '@util/getUserAgent';

import { Container } from './styles';

interface IProps {
  hide: () => void;
  userIsManager: boolean;
}

const today = new Date();

const WebActions = ({ userIsManager, hide }: IProps) => (
  <>
    {!userIsManager && (
      <>
        <Button
          href="https://apps.apple.com/br/app/somabox/id1636403657"
          target="_blank"
        >
          <p className="modalButton">BAIXAR O BOX - IOS</p>
        </Button>
        <Button
          href="https://play.google.com/store/apps/details?id=app.somalabs.somabox&pcampaignid=web_share"
          target="_blank"
        >
          <p className="modalButton">BAIXAR O BOX - ANDROID</p>
        </Button>
      </>
    )}
    {userIsManager && (
      <Button href="https://somabox.somalabs.com.br/">
        <p className="modalButton">IR PARA O BOX</p>
      </Button>
    )}
    <Button
      variant="outlined"
      onClick={() => {
        if (typeof hide === 'function') hide?.();
      }}
    >
      <p className="modalButton">FAZER ISSO MAIS TARDE</p>
    </Button>
  </>
);

const MobileActions = ({
  userIsManager,
  hide,
  currentOs,
}: IProps & {
  currentOs: 'ANDROID' | 'IOS';
}) => {
  const storeUrl = {
    ANDROID:
      'https://play.google.com/store/apps/details?id=app.somalabs.somabox&pcampaignid=web_share',
    IOS: 'https://apps.apple.com/br/app/somabox/id1636403657',
  };

  return (
    <>
      {!userIsManager && (
        <Button href={storeUrl[currentOs]} target="_blank">
          <p className="modalButton">BAIXAR O BOX - IOS</p>
        </Button>
      )}
      {userIsManager && (
        <Button href="https://somabox.somalabs.com.br/">
          <p className="modalButton">IR PARA O BOX - URL</p>
        </Button>
      )}
      <Button
        variant="outlined"
        onClick={() => {
          if (typeof hide === 'function') hide?.();
        }}
      >
        <p className="modalButton">FAZER ISSO MAIS TARDE</p>
      </Button>
    </>
  );
};

const SomaBoxAlert: React.FC<IProps> = ({ hide, userIsManager = false }) => {
  const currentOs = getUserAgent();

  const shutdownDate = new Date(today.getFullYear(), 4, 30);

  const isBeforeShutdownDay = today.getTime() < shutdownDate.getTime();

  const millisecondsPerDay = 1000 * 60 * 60 * 24;

  const daysToShutdown = Math.ceil(
    (shutdownDate.getTime() - today.getTime()) / millisecondsPerDay,
  );

  return (
    <Container>
      <div className="closeRow">
        <button
          type="button"
          onClick={() => {
            if (typeof hide === 'function') hide?.();
          }}
        >
          <MdOutlineClose className="closeIcon" />
        </button>
      </div>
      <div className="iconRow">
        <div className="iconImage">
          <p>
            <MdOutlineStorefront />
          </p>
        </div>
      </div>
      <div className="titleRow">
        <p>
          OBRIGADO PELO SEU TEMPO <br />
          COM O SOMASTORE!
        </p>
      </div>
      <div className="textRow">
        {isBeforeShutdownDay && (
          <>
            <p>
              {daysToShutdown === 0 ? (
                <p>
                  <strong>Hoje é o último dia de acesso</strong> ao SomaStore.
                </p>
              ) : (
                <>
                  O acesso ao SomaStore <strong>será removido</strong> daqui a{' '}
                  <strong>
                    {daysToShutdown} {daysToShutdown === 1 ? 'dia' : 'dias'}
                  </strong>
                  .
                </>
              )}
            </p>
            <p>Obrigado por todo o tempo que passamos juntos :)</p>
            <p>
              Agora vocês possuem o <strong>Box</strong> para continuar
              realizando seus atendimentos!
            </p>
          </>
        )}

        {!isBeforeShutdownDay && (
          <>
            <p>
              Agora vocês possuem o <strong>Box</strong>, para continuar
              realizando seus atendimentos!
            </p>
            <p>
              Abaixo os links do <strong>Box</strong> para você acessar.
            </p>
          </>
        )}
      </div>
      <div className="actionArea">
        {currentOs === 'NAO_IDENTIFICADO' && (
          <WebActions hide={() => hide?.()} userIsManager={userIsManager} />
        )}
        {currentOs !== 'NAO_IDENTIFICADO' && (
          <MobileActions
            hide={() => hide?.()}
            userIsManager={userIsManager}
            currentOs={currentOs}
          />
        )}
      </div>
    </Container>
  );
};

export { SomaBoxAlert };
